import { render, staticRenderFns } from "./Shenhe.vue?vue&type=template&id=5b775a02&scoped=true&"
import script from "./Shenhe.vue?vue&type=script&lang=js&"
export * from "./Shenhe.vue?vue&type=script&lang=js&"
import style0 from "./Shenhe.vue?vue&type=style&index=0&id=5b775a02&scoped=true&lang=css&"
import style1 from "./Shenhe.vue?vue&type=style&index=1&id=5b775a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b775a02",
  null
  
)

export default component.exports